// vAI avatar states for the chat experience.
//
// The avatar reacts to the conversation: idle on the welcome screen (and
// while the user types — the "listening" moment deliberately reuses the
// regular portrait), thinking once a message is sent, then alternating
// between thinking and typing while a slow reply is still being generated
// (the timeout cycle), and speaking while tokens stream in.

export const VAI_AVATARS = {
  idle: "/images/vai-avatar.jpg",
  thinking: "/images/vai-thinking.jpg",
  typing: "/images/vai-typing.jpg",
  speaking: "/images/vai-speaking.jpg",
};

// Listening uses the regular portrait — no separate artwork.
export function avatarFor(state) {
  return VAI_AVATARS[state] || VAI_AVATARS.idle;
}

export const AVATAR_STATUS = {
  idle: "Vaibhav\u2019s personal AI",
  thinking: "vAI is thinking\u2026",
  typing: "vAI is looking things up\u2026",
  speaking: "vAI is speaking\u2026",
};

export function statusFor(state) {
  return AVATAR_STATUS[state] || AVATAR_STATUS.idle;
}

// How long to wait for a reply before cycling the thinking avatars,
// and how long each one shows before switching.
export const THINK_TIMEOUT_MS = 5000;
export const THINK_CYCLE_MS = 4000;

// Alternate the two "working" avatars while a reply is slow.
export function nextThinkingAvatar(current) {
  return current === "thinking" ? "typing" : "thinking";
}
